// extracted by mini-css-extract-plugin
module.exports = {"blocksWrapper":"AllTogetherNow_blocksWrapper__1m28S"};